import { useState, forwardRef, useImperativeHandle } from "react";
import { GLOBAL_LINKS_BAIXAR_APP } from "../../../pages/global/links";
import { ShowFieldPopUp } from "../../AlertPopUp/FieldPopUp";
import { IconAndroid, IconChevronRight, IconClose, IconIOS } from "../../Icons";
import styles from './AppDownloadModal.module.css';
import { utils_site_ref_launch_app } from "../../utils/utils_site_ref";

export const AppDownloadModal = forwardRef((_, ref) => {

    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    // 🔹 Expõe funções para o componente pai
    useImperativeHandle(ref, () => ({
        openModal,
        closeModal,
    }));

    const Option = ({ icon, color, bg, title, text, onClick }) => (
        <button
            className={styles.option}
            style={{ background: bg }}
            onClick={() => {
                onClick();
                closeModal();
            }}
        >
            <div
                className={styles.iconBox}
                style={{
                    background: bg === "#EFF6FF" ? "#DBEAFE" : "#DCFCE7",
                }}
            >
                {icon}
            </div>
            <div className={styles.textBox}>
                <h2>{title}</h2>
                <p>{text}</p>
            </div>
            <IconChevronRight className={styles.chevron} color="#444" />
        </button>
    );

    if (!isOpen) return null;

    return (
        <ShowFieldPopUp
            Title={
                <header className={styles.header}>
                    <h1>Selecione como usar o TooMe</h1>
                    <IconClose className={styles.close} color="#444" onClick={closeModal} />
                </header>
            }
            TitleDom={
                <section className={styles.container}>
                    <Option
                        icon={<IconIOS color="#2563EB" />}
                        bg="#EFF6FF"
                        title="IOS"
                        text="Usar versão web do aplicativo"
                        onClick={utils_site_ref_launch_app}
                    />
                    <Option
                        icon={<IconAndroid color="#16A34A" />}
                        bg="#F0FDF4"
                        title="Android"
                        text="Baixar aplicativo na Google Play Store"
                        onClick={() => {
                            window.open(GLOBAL_LINKS_BAIXAR_APP, '_blank')
                        }}
                    />
                </section>
            }
            OnSend={closeModal}
            OnCancel={closeModal}
            Fields={[]}
            CancelButtonText=""
            SendButtonText=""
        />
    );
});
